import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"

import { addErrorNotification } from "../notifications/actions"
import { scriptingAPI } from "../../apis"
import { Exceptions } from "../../util/Translations"
import { formatString } from "../../util/Strings"
import { IScriptingItem } from "../../models/scripting"
const { AnErrorOccurredWhileExecutingAction } = Exceptions

const initialState: IScriptingItem = {
    isScriptSaved: {},
    isScriptSavingFailed: {},
    isScriptRunning: {},
}

export const executeAction = createAsyncThunk(
    "scripting/executeAction",
    async (
        { action, conceptId, itemId, fieldId }: ExecuteActionParameters,
        { getState: _getState, dispatch },
    ) => {
        try {
            const { scriptId, listScriptId, hasParameters } =
                await scriptingAPI.getScriptInformation(
                    action,
                    conceptId,
                    itemId,
                )

            await scriptingAPI.executeScript({
                scriptId,
                listScriptId,
                hasParams: hasParameters,
                itemId,
                cFieldId: Number.parseInt((fieldId ?? "").slice(2)),
            })
            dispatch(markScriptSuccess(action))
            setTimeout(() => {
                dispatch(resetScriptState(action))
            }, 3000)
            return { actionId: action }
        } catch (error) {
            let errorMessage = formatString(
                AnErrorOccurredWhileExecutingAction,
                action,
            )
            if (error instanceof Error) {
                errorMessage = `${errorMessage} ${error.message}`
            }
            console.error(`${errorMessage}`, error)
            dispatch(addErrorNotification(errorMessage))
            dispatch(markScriptFailed(action))

            setTimeout(() => {
                dispatch(resetScriptState(action))
            }, 3000)

            throw error
        }
    },
)

export const scriptingSlice = createSlice({
    name: "scripting",
    initialState,
    reducers: {
        handleExecutionStarted(state, action: PayloadAction<string>) {
            const id = action.payload
            state.isScriptRunning[id] = true
        },
        markScriptSuccess(state, action: PayloadAction<string>) {
            const id = action.payload
            state.isScriptSaved[id] = true
            state.isScriptRunning[id] = false
        },
        markScriptFailed(state, action: PayloadAction<string>) {
            const id = action.payload
            state.isScriptSavingFailed[id] = true
            state.isScriptRunning[id] = false
        },
        resetScriptState(state, action: PayloadAction<string>) {
            const id = action.payload
            delete state.isScriptSaved[id]
            delete state.isScriptSavingFailed[id]
            delete state.isScriptRunning[id]
        },
        resetAllScriptState(state) {
            state.isScriptSaved = {}
            state.isScriptSavingFailed = {}
            state.isScriptRunning = {}
        },
    },
})

export const {
    handleExecutionStarted,
    markScriptSuccess,
    markScriptFailed,
    resetScriptState,
    resetAllScriptState,
} = scriptingSlice.actions

export default scriptingSlice.reducer
export interface ExecuteActionParameters {
    action: string
    conceptId?: number
    itemId?: number
    fieldId?: string
}
